/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ExportOptions } from "./ExportOptions";
export const ExportJobConfig = core.serialization.object({
    options: ExportOptions,
});
